// Helps to manage elements "jumping" when scrollbar is hidden
!function () {
  const html = document.querySelector( 'html' );

  // https://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript/13382873#13382873
  const getScrollbarWidth = () => {
    // Creating invisible container
    const outer = document.createElement( 'div' );
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild( outer );

    // Creating inner element and placing it in the container
    const inner = document.createElement( 'div' );
    outer.appendChild( inner );

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = ( outer.offsetWidth - inner.offsetWidth );

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild( outer );

    return scrollbarWidth;
  }

  const applyPaddingForScrollbar = () => {
    const searchButton = document.querySelector( '.go777545767' );
    const documentWrap = document.querySelector( '.document-wrap' );

    const scrollbarWidth = getScrollbarWidth();
    if ( html.classList.contains( 'ncstate-utility-bar-lock-scroll' ) ) {
			if (searchButton) searchButton.style.paddingRight = `${ scrollbarWidth }px`;
      documentWrap.style.paddingRight = `${ scrollbarWidth }px`;
    } else {
			if ( searchButton ) searchButton.style.paddingRight = ``;
      documentWrap.style.paddingRight = ``;
    }
  }

  // Throws benign error => "ResizeObserver loop completed with undelivered notifications."
  // Safe to ignore based on https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded#50387233
  const resizeObserver = new ResizeObserver( () => applyPaddingForScrollbar() )
  resizeObserver.observe( document.body )
}();
